const transRarity = {
  0: 'normal',
  1: 'rare',
  2: 'superRare',
  3: 'ultraRare',
};

const deliveryStatus = {
  0: '対象外',
  1: '未発送',
  2: '発送済み',
};

const shopLink = {
  '(at minny online store)': 'https://www.iranoan.com/blank-3/Point-for-Get24',
};

const ExchangeSearch = {
  0: 'Highest price',
  1: 'Lowest price',
  2: 'Most stock',
  3: 'Least stock',
};

export {
  transRarity,
  deliveryStatus,
  shopLink,
  ExchangeSearch,
};
